import { useQuery } from "@tanstack/react-query";
import { useServices } from "index";

export const useGetAdminOrganization = (organizationId: string | undefined) => {
  const organizationsEditorService = useServices().organizationsEditorService;

  return useQuery({
    queryKey: ['adminOrganization', organizationId],
    queryFn: () => organizationsEditorService.getOrganization(organizationId!),
    enabled: !!organizationId,
    refetchOnWindowFocus: false,
  });
};
